export default __webpack_public_path__ + "static/media/alphabet-yellow-x.1bba6cb6.png";